// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Es6Promise from 'es6-promise'

require('es6-promise').polyfill()
Es6Promise.polyfill()
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import axios from 'axios'
import qs from 'qs'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'
import store from './store'
import WeVue from 'we-vue'
import 'we-vue/lib/style.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui'
import VueScroller from 'vue-scroller';
import echarts from 'echarts'
import Vant from 'vant'
import { Lazyload } from 'vant';
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'

Vue.prototype.$echarts = echarts
Vue.use(VueScroller)
// import less from 'less'

Vue.use(ElementUI)
//Vue.use(Vant)
Vue.config.productionTip = false

import mui from './assets/mui/js/mui.js'
import rem from './assets/mui/js/rem.js'
import './assets/mui/css/mui.css'
import './assets/mui/css/style.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/mui/css/xiug.css'
import './assets/mui/css/proxy.css'
import './assets/oil_card/css/fonts/iconfont.css'
import './assets/oil_card/css/oil_style.css'
import './assets/mui/css/mui.showLoading.css'
import './assets/mui/js/mui.showLoading.js'
import './assets/mui/css/mui.poppicker.css'
import './assets/mui/js/mui.poppicker.js'
import './assets/mui/css/mui.picker.css'
import './assets/mui/js/mui.picker.js'
import './assets/mui/js/mui.view.js'
import citydata from './assets/mui/js/city.data.js'
import citydata3 from './assets/mui/js/city.data3.js'
import './assets/mui/js/validate'

const query = qs.parse(location.hash.substring(3))

Vue.prototype.citydata = citydata
Vue.prototype.citydata3 = citydata3
Vue.prototype.mui = mui
axios.defaults.withCredentials = false
axios.defaults.crossDomain = true
axios.defaults.timeout = 50000                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'        //配置请求头
//配置
//生产环境
axios.defaults.baseURL = 'https://yk.ioccn.com/';
store.state.webdomain='http://app.ioccn.com/';
store.dispatch("updateWebdomain", 'http://app.ioccn.com/');
store.state.domain=axios.defaults.baseURL;
store.dispatch("updateDomain", axios.defaults.baseURL);
//开发测试环境
// axios.defaults.baseURL = 'http://192.168.0.166:8080/' //后端API域名地址
// store.state.webdomain = 'http://192.168.0.166:8081/'
// store.dispatch('updateWebdomain', 'http://192.168.0.166:8081/')//当前地址
// store.state.domain = axios.defaults.baseURL
// store.dispatch('updateDomain', axios.defaults.baseURL)
// 本地测试环境
// axios.defaults.baseURL = 'http://localhost:8066/'; //后端API域名地址
// store.state.webdomain='http://localhost:8081/';
// store.dispatch("updateWebdomain", 'http://localhost:8081/');//当前地址
// store.state.domain=axios.defaults.baseURL;
// store.dispatch("updateDomain", axios.defaults.baseURL);

const wx = {
  getStorageSync (key) {
    return localStorage.getItem(key)
  },
  removeStorageSync (key) {
    return localStorage.removeItem(key)
  },
  alert (option, callback) {
    if (typeof option == 'string') {
      if (callback) {
        mui.alert(option, null, null, callback, 'div')
      } else {
        mui.alert(option)
      }
    } else {
      mui.alert(option.message, option.title, option.btnValue, option.callback, 'div')
    }

  },
  confirm (option) {
    if (typeof option == 'string') {
      mui.confirm(option)
    } else {
      mui.confirm(option.message, option.title, option.btnValue, option.callback, 'div')
    }
  },
  prompt (option) {
    if (typeof option == 'string') {
      mui.prompt(option)
    } else {
      mui.prompt(option.message, option.placeholder, option.title, option.btnValue, option.callback, 'div')
    }

  },
  toast (option) {
    if (typeof option == 'string') {
      mui.toast(option)
    } else {
      mui.toast(option.message == null ? option.title : option.message, {
        duration: option.duration,
        type: 'div',
      })
      if (option.callback) {
        setTimeout(option.callback, option.duration)
      }
    }
  },
  showToast (option) {
    if (typeof option == 'string') {
      mui.toast(option)
    } else {
      mui.toast(option.message == null ? option.title : option.message, {
        duration: option.duration,
        type: 'div',
      })
      if (option.callback) {
        setTimeout(option.callback, option.duration)
      }
    }
  },
  showToast (option, duration, callback) {
    if (typeof option == 'string') {
      mui.toast(option, {
        duration: duration,
        type: 'div',
      })
      if (callback) {
        setTimeout(callback, duration)
      }
    } else {
      mui.toast(option.message == null ? option.title : option.message, {
        duration: option.duration,
        type: 'div',
      })
      if (option.callback) {
        setTimeout(option.callback, option.duration)
      }
    }

  },
  showLoading (txt) {
    if (typeof txt == 'object') {
      txt = txt.title
    }
    mui.showLoading(txt ? txt : '加载中', 'div') //加载文字和类型，plus环境中类型为div时强制以div方式显示
  },
  hideLoading (callback) {
    mui.hideLoading(callback)//隐藏后的回调函数
  },
  showModal (option) {
    if (typeof option.success == 'function') {
      option.callback = option.success
    }
    mui.confirm(option.content, option.title, option.btnValue, function(result){
		if(result.index == '1'){
			result['confirm'] = true;
		}else{
			result['confirm'] = false;
		}
		option.callback.call({},result);
	}, 'div')
  },
  navigateTo (option) {
    console.log('跳转链接')
    router.push(option.url)
  },
  redirectTo (option) {
    console.log('跳转链接')
    router.push(option.url)
  },
  navigateBack () {
    router.back(-1)
  }
}

Vue.use(VueAwesomeSwiper)
import {DatetimePicker} from 'we-vue'

Vue.use(DatetimePicker)
Vue.use(WeVue)
Vue.use(VueResource)
Vue.use(Vuex)
Vue.config.productionTip = false
Vue.prototype.$https = axios
Vue.prototype.$wx = wx
Vue.prototype.$qs = qs
Vue.prototype.$dayjs = dayjs
Vue.prototype.$query = query
Vue.prototype.$cookies = Cookies

const app = {
  r (url, params, succFunc, failFunc) {
    var p = {
      token: store.state.token,
      appuid: store.state.userInfo.unionid
    }
    if (params) {
      for (var n in params) {
        p[n] = params[n]
      }
    }
    Vue.prototype.$https.post(url, Vue.prototype.$qs.stringify(p)).then((res) => {
      if (typeof succFunc == 'function') {
        succFunc.call(this, res.data)
      }
    }).catch((res) => {
		console.log(res);
      if (typeof failFunc == 'function') {
        failFunc.call(this, res)
      } else {
        Toast.text({
          duration: 1000,
          message: res
        })
      }
    })
  },
  pr (url, params) {
    var that = this
    return new Promise((resolve, reject) => {
      this.r(url, params, function (res) {
        resolve(res)
      }, function (res) {
        reject(res)
      })
    })
  },
  eventAudioList:{
		ended:[]
	},
	addAudioEvent(event,callback){
		if(event == 'ended'){
			this.eventAudioList.ended.push(callback);
			$('audio')[0].addEventListener('ended',callback);
		}
	},
	clearAudioEvent(event){
		for(var n in this.eventAudioList.ended){
			$('audio')[0].removeEventListener('ended',this.eventAudioList.ended[n]);
		}
		this.eventAudioList.ended = [];
  },
  audio: {
    vplaypause () {
      $('audio')[0].pause()
    },
    vplaypauseplay () {
      $('audio')[0].play()
    },
    vplaystop () {
      try {
        $('audio')[0].src = 'http://jk.ioccn.com/k.mp3'
      } catch (ex) {
        console.log(ex)
      }

    },
    stop () {
      this.vplaystop()
    },
    play (string, callback) {
      if (store.state.userInfo.id == 23963) {
        //alert('播放ZT：'+($('audio').attr('src').indexOf('k.mp3'))+'src:'+$('audio').attr('src'))
      }
      if ($('audio').attr('src').indexOf('k.mp3') != -1) {
        $('audio')[0].play()
      }
      var p = {
        appuid: store.state.userInfo.unionid,
        text: string
      }
      Vue.prototype.$https.post('/api/common/voice.html', Vue.prototype.$qs.stringify(p)).then((res) => {
        $('audio').attr('src', res.data.data)[0].play()
        $('audio')[0].addEventListener('ended', callback)
      }).catch((res) => {
        Toast.text({
          duration: 1000,
          message: res
        })
      })
    },
    vplay (string, callback) {
      this.play(string, callback)
    },
    bplay (string, callback) {
      this.play(string, callback)
    },
  },
  IdentityCodeValid: function (code) {
    var city = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江 ',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北 ',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏 ',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外 '
    }
    var tip = ''
    var pass = true

    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
      tip = '身份证号格式错误'
      pass = false
    } else if (!city[code.substr(0, 2)]) {
      tip = '地址编码错误'
      pass = false
    } else {
      //18位身份证需要验证最后一位校验位
      if (code.length == 18) {
        code = code.split('')
        //∑(ai×Wi)(mod 11)
        //加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        //校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
        var sum = 0
        var ai = 0
        var wi = 0
        for (var i = 0; i < 17; i++) {
          ai = code[i]
          wi = factor[i]
          sum += ai * wi
        }
        var last = parity[sum % 11]
        if (parity[sum % 11] != code[17]) {
          tip = '校验位错误'
          pass = false
        }
      }
    }
    return pass
  },
  locationAddress: false,
  locationAddressDetail: [],
  locationAddressed: false,
  getCurrentPositionByPhone(high){
	var that = this;
	wx.showLoading('正在获取位置')
	return new Promise((resolve,reject) => {
		/*if(!window.plus){
			resolve({
				location:{
					longitude:102.780802,
					latitude:24.986664
				}
			});
		}else{*/
			app.getPlus().then(() => {
				plus.geolocation.getCurrentPosition(function(position){
					wx.hideLoading()
					resolve({
						location:{
							longitude:position.coords.longitude,
							latitude:position.coords.latitude,
							coordsType:position.coordsType
						}
					});
				}, function(error){
					wx.hideLoading()
					reject(error);
				});
			})
		//}
	});
  },
  getPlus(){
	return new Promise((resolve,reject) => {
		if(typeof window.plus == 'undefined'){
			document.addEventListener('plusready', function () {
				resolve({});
			})
		}else{
			resolve({});
		}
	});
  },
  getCurrentPosition (high) {
    var that = this
    return new Promise((resolve, reject) => {
      if (that.locationAddressed) {
        resolve(that.locationAddress)
      } else {
        wx.showLoading('正在获取位置')
        try {
          var geolocation = new BMap.Geolocation()
          geolocation.getCurrentPosition(function (r) {
            wx.hideLoading()
			console.log("fdsdf");
			console.log(JSON.stringify(r));
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
              that.locationAddress = JSON.stringify({
                location: {
                  latitude: r.point.lat,
                  longitude: r.point.lng
                }
              })
              that.locationAddressed = true
              resolve(that.locationAddress)

              //alert('您的位置：'+r.point.lng+','+r.point.lat);
            } else {
              reject({
                msg: '定位失败'
              })
            }
          },{
			enableHighAccuracy:high ? true : false
          })
          /*navigator.geolocation.getCurrentPosition(function(position){
            alert('开始定位');
            wx.hideLoading()
            that.locationAddress = position;
            that.locationAddressed = true;
            resolve(that.locationAddress)
          },function(){
            alert('定位失败');
            wx.hideLoading()
            reject({
              msg:'定位失败'
            })
          },{
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge:60*1000
          });*/
        } catch (e) {
          alert(e)
        }
      }
    })
  },
  reloadUser () {
    var that = this
    this.pr('/api/appuser/get_user.html').then((res) => {
      if (res.success) {
        that.refreshUser(res.data)
      }
    }, (res) => {
      console.log(res)
    })
  },
  refreshUser (userInfo) {
    if (userInfo) {
      localStorage.setItem('login_user', JSON.stringify(userInfo))//记录用户登录状态
      store.dispatch('updateUser', userInfo)
    }
  },
  goTo (url, p = {}) {//跳转 带参数
    router.push({path: url, query: p})
  },
  gasGoTo (url, p = {}) {//跳转 带参数
    if(url != '/'){
		this.goTo(url,p);
    }else{
		plus.webview.currentWebview().hide();
    }
  },
  getParam (key) {//获取参数
    var options = router.app._route.query
    return options[key]
  },
  goBack () {
    if (typeof plus == 'undefined') {
      router.back(-1)
    } else {
      plus.webview.currentWebview().back()
    }
  }
}

Vue.prototype.$app = app

new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})

// 系统错误捕获
const errorHandler = (error, vm)=>{
  console.error('抛出全局异常:')
  console.log(error)
}

Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error)=> errorHandler(error,this);



// WEBPACK FOOTER //
// ./src/main.js